export enum RawmaterialOrSampleStatus {
    ENABLED = 0,
    DISABLED = 1,
    ARCHIVED = 2,
}
